import { NgModule } from '@angular/core'
import { CepPipe } from './cep/cep.pipe'
import { CnpjPipe } from './cnpj/cnpj.pipe'
import { CnrmPipe } from './cnrm/cnrm.pipe'
import { CpfPipe } from './cpf/cpf.pipe'
import { InfoLabelPipe } from './label/info.pipe'
import { PCPPipe } from './pcp/pcp.pipe'
import { ProtocoloPipe } from './protocolo/protocolo.pipe'
import { TelefonePipe } from './telefone/telefone.pipe'
import { TruncatePipe } from './truncate/truncate.pipe'

@NgModule({
  declarations: [
    CpfPipe,
    CnpjPipe,
    CepPipe,
    TelefonePipe,
    InfoLabelPipe,
    CnrmPipe,
    PCPPipe,
    ProtocoloPipe,
    TruncatePipe,
  ],
  exports: [CpfPipe, CnpjPipe, CepPipe, TelefonePipe, InfoLabelPipe, CnrmPipe, PCPPipe, ProtocoloPipe, TruncatePipe],
})
export class PipesModule {}
